import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '@/lib/utils';
import { BASE_URL } from '@/constants';

const BaseAvatar = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn(
      'relative flex h-[32px] w-[32px] shrink-0 overflow-hidden rounded-full',
      className,
    )}
    {...props}
  />
));
BaseAvatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn('aspect-square h-full w-full', className)}
    {...props}
  />
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Fallback>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      'flex h-full w-full items-center justify-center rounded-full bg-muted',
      className,
    )}
    {...props}
  />
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export interface AvatarProps {
  src: string;
  fallback?: React.ReactNode;
  size?: number;
  className?: string;
  fallbackClassName?: string;
}
const Avatar: React.FC<AvatarProps> = ({ src, fallback, size, className, fallbackClassName }) => {
  return (
    <BaseAvatar className={className} style={{ width: size, height: size }}>
      <AvatarImage src={src} />
      <AvatarFallback className={cn(fallbackClassName)}>
        {fallback ?? <img src={`${BASE_URL}/momo.png`} className={`size-[${size}px]`} />}
      </AvatarFallback>
    </BaseAvatar>
  );
};

export { Avatar, BaseAvatar, AvatarImage, AvatarFallback };
